<div class="flex flex-col w-full h-full gap-y-2">
	<app-pdftron
		#pdfViewer
		[base64Encoded]="drawerData().docxBase64"
		[fileName]="drawerData().fileName"
	></app-pdftron>
</div>
